import styled from 'styled-components';

export const StyledBallotsSection = styled.div`
	margin-top: 16px;
`;
